export default "__VITE_ASSET__JeaFKuwc__"